import { useEffect, useState } from 'react'
import Header from '../../sections/header/Header'
import Footer from '../../sections/footer/Footer'
import { InstructorProfileData } from '../../server/types'
import InstructopProfileHero from '../../sections/instructorProfileHero/InstructopProfileHero'
import InstructorProfileContent from '../../sections/instructorProfileContent/InstructorProfileContent'
import InstructorProfileAwards from '../../sections/instructorProfileAwards/InstructorProfileAwards'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import InstructorProfileThingsToKnow from '../../sections/instructorProfileThingsToKnow/InstructorProfileThingsToKnow'
import InstructorProfileHighlightCard from '../../sections/instructorProfileHighlightCard/InstructorProfileHighlightCard'
import InstructorProfileRating from '../../sections/instructorProfileRating/InstructorProfileRating'
import InstructorProfileReviews from '../../sections/instructorProfileReviews/InstructorProfileReviews'
import { instructorProfileConnector } from '../../server/connector/instructorProfileConnector'
import { instructorStateData } from '../../data/instructorStateData'
// import { useAppDispatch } from '../../redux/hooks'

function InstructorsProfile() {
	// const [profileRequestCompleted, setProfileRequestCompleted] = useState<boolean>(false)
	const [instructorProfileData, setInstructorProfileData] = useState<InstructorProfileData | undefined>(instructorStateData.profileData)

	// const dispatch = useAppDispatch()

	useEffect(() => {
		// initializeSite()
		requestProfile()
	}, [])

	const requestProfile = () => {
		const querySting: string = window.location.search;
		const urlParams: URLSearchParams = new URLSearchParams(querySting)
		const profileId: string | null = urlParams.get('id')

		if (instructorProfileConnector.requestInProgress) {
			console.log('[InstructorsProfile] - requestProfile() called while requestInProgress')
		} else {
			if (profileId) {
				instructorProfileConnector.getInstructorProfileRequest(profileId).then((successRequest) => {
					if (instructorStateData.profileData === undefined) {
						console.log('WARNING - [InstructorsProfile] - requestProfile() failed, undefined result')
					} else {
						setInstructorProfileData(instructorStateData.profileData)
					}
					// setProfileRequestCompleted(true)
					if (!successRequest) {
						console.log('WARNING - [InstructorsProfile] - requestProfile() failed')
					}
				})
			}
		}
	}

	// // Called on initial page load and used to prepare the site
	// const initializeSite = () => {
	// 	const tempProfile: InstructorProfileData = {
	// 		id: '35',
	// 		name: 'Test Instructor',
	// 		school: 2,
	// 		rating_overall: '3.5',
	// 		rating_analysis: '3.2',
	// 		rating_communication: '3.9',
	// 		rating_quick_replies: '2.5',
	// 		rating_encouragement: '4.3',
	// 		level: 3,
	// 		review_count: 345,
	// 		years_of_experience: 12,
	// 		price: '£35.00',
	// 		terrains: '1,3',
	// 		languages: '0,2',
	// 		about_text: 'Lena Skarsgård is a highly experienced ski and snowboard instructor with over eight years of teaching at top resorts across Europe and North America, including Verbier, Whistler Blackcomb, and Aspen. Certified as a Level 3 Ski Instructor (ISIA) and a Level 2 Snowboard Instructor (AASI), Lena brings a patient, positive, and personalized approach to every lesson.<p>She specializes in advanced techniques, terrain park fundamentals, and off-piste guiding for certified areas. Fluent in English, Swedish, and French, Lena works comfortably with students of all ages and backgrounds, including children and adaptive athletes. With a strong focus on building confidence, mastering fundamentals, and promoting mountain safety, Lena strives to make every day on the slopes a fun and rewarding experience. Off the mountain, she enjoys backcountry touring, yoga, and photography, often blending her passions during her outdoor adventures.',
	// 		awards: 'QUICK_REPLY_GOLD,TOP_RATED_GOLD,EXPERIENCED_GOLD,PERSONALIZED',
	// 		profile_pics: 'profile-m-00000.png,profile-m-00001.png,profile-m-00002.png'
	// 	}
	// 	setInstructorProfileData(tempProfile)
	// }

	return (
		<>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Header />
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				{instructorProfileData && 
					<>
						<InstructopProfileHero profileData={instructorProfileData} />
						{ instructorProfileData.awards && instructorProfileData.awards.length > 0 && <InstructorProfileAwards profileData={instructorProfileData} /> }
						<InstructorProfileContent profileData={instructorProfileData} />
						<InstructorProfileHighlightCard profileData={instructorProfileData} />
						<InstructorProfileRating profileData={instructorProfileData} />
						<InstructorProfileReviews profileData={instructorProfileData} />
					</>
				}
				<InstructorProfileThingsToKnow />
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
			<BackToTopButton />
		</>
	)
}

export default InstructorsProfile
